export default {
  show: 'Show',
  entries: 'entries',
  previous: 'Previous',
  next: 'Next',
  showing: 'Showing',
  showingTo: 'to',
  showingOf: 'of',
  showingEntries: 'entries'
}
